/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Dimension_Project_ClarityInputs */

const en_directory_agent_readiness_dimension_project_clarity = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Project_ClarityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project clarity`)
};

const zh_directory_agent_readiness_dimension_project_clarity = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Project_ClarityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目定位清晰度`)
};

/**
* | output |
* | --- |
* | "Project clarity" |
*
* @param {Directory_Agent_Readiness_Dimension_Project_ClarityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_dimension_project_clarity = /** @type {((inputs?: Directory_Agent_Readiness_Dimension_Project_ClarityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Dimension_Project_ClarityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_dimension_project_clarity(inputs)
	return zh_directory_agent_readiness_dimension_project_clarity(inputs)
});
export { directory_agent_readiness_dimension_project_clarity as "directory.agent_readiness.dimension.project_clarity" }